import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Button, TextField, Typography, Grid, Select, Card, CardHeader, CardContent, Divider, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useRouter from 'utils/useRouter';
import { Page, Header, Map, SelectField, Label, SearchBar, FiltersDrawer, DatePicker } from 'components';
import Layer3DataTables from './components/Layer3DataTables';
import Layer3Charts from './components/Layer3Charts';
import Layer3Map from './components/Layer3Map';

const Layer3Form = (props) => {
	// const layer3 = useSelector((state) => state.voiceReducer.layer3);
	const layer3Failure = useSelector((state) => state.voiceReducer.layer3Failure);
	// const layer3Kpis = useSelector((state) => state.voiceReducer.layer3Kpis);

	return (
		<div>
			<Layer3DataTables />
			<Grid container spacing={4}>
				<Grid item md={6} xs={6}>
					<Layer3Map />
				</Grid>
				<Grid item md={6} xs={6}>
					<Layer3Charts />
				</Grid>
			</Grid>
		</div>
	);
};

export default Layer3Form;
